<div class="topup-icon position-relative">
  <app-icon name="dollar" class="dollar" matListIcon [size]="sizeDollar"></app-icon>
  <app-icon name="smartphone" class="smartphone mr-8 border mr-24" matListIcon [size]="sizeSmartphone"></app-icon>
</div>
